import '@swc/helpers';
import '@grandvisionhq/utils';
import { getPageType } from '../utils/get-page-type.js';
import '@grandvisionhq/lib-utils-react';
import { pushEvent } from './helpers.js';

const pushPageTypeToDataLayer = (seoPageType, pageName)=>{
    /**
   * Since we don't use Bloomreach for the CO and MyAccount we need to prevent
   * sending this event for those pages. PageType will be send from the CO and
   * MyAccount packages
   */ const name = pageName === null || pageName === void 0 ? void 0 : pageName.replace(/-/g, ' ').toLowerCase();
    const pageType = getPageType(seoPageType);
    const searchParams = new URLSearchParams(window.location.search);
    if (name === 'pagenotfound' || (name === null || name === void 0 ? void 0 : name.includes('checkout')) || (name === null || name === void 0 ? void 0 : name.includes('product detail page')) || pageType === 'product listing' && searchParams && searchParams.toString() !== '' || seoPageType === undefined) {
        return;
    }
    pushEvent({
        event: 'page_data_loaded',
        page: {
            unixTimestamp: Math.floor(Date.now() / 1000),
            type: pageType
        }
    });
};

export { pushPageTypeToDataLayer };
//# sourceMappingURL=pageType.js.map
